import React from 'react';
import { useHistory } from "react-router-dom";
import GradientButton from "@tomocredit/common-fe/components/common/GradientButton";
import RightArrowIcon from "images/arrow-right-double.svg";

const ActionButton = ({ text, isMobile }) => {
  const history = useHistory();
  return (
    <GradientButton
      clickMethod={() => history.push("/boost-pricing")}
      background="rgba(114, 73, 245, 1)"
      width={isMobile ? "100%" : "75%"}
      height={isMobile ? null : "48px"}
      fontWeight={isMobile ? 600 : 800}
    >
      <span className="flex flex-row ignore text-white text-lg">
        {text}
        <img alt="" src={RightArrowIcon} />
      </span>
    </GradientButton>
  );
};

const ActionText = ({
  title,
  buttonText,
  belowMd,
  children,
}) => {
  return (
    <div className="bg-neutral-50 py-8 sm:px-8 md:px-10 md:pt-[60px] md:pb-[45px] flex-1 flex flex-col rounded-lg shrink-0 text-left gap-6">
      <div className="flex flex-col gap-6 md:p-10">
        <div className="font-bold leading-tight text-3xl text-boost-primary-500 text-start">
          {title}
        </div>
        {children}
      </div>
      <div className="w-full h-[42px] grid place-items-center">
        <ActionButton text={buttonText} isMobile={belowMd} />
      </div>
    </div>
  );
};

const ActionImage = ({ src, belowMd }) => (
  <img
    alt=""
    src={src}
    className="w-full"
    style={{
      maxWidth: belowMd ? 378 : 438,
      height: "auto",
      objectFit: "cover",
    }}
  />
);

const ActionCard = ({
  title,
  buttonText,
  src,
  belowMd,
  isImageLeft = true,
  children,
}) => {
  const imgClassName = isImageLeft ? "order-1" : "order-1 md:order-2";
  const textClassName = isImageLeft ? "order-2" : "order-2 md:order-1";
  return (
    <div
      className="py-8 md:py-0 grid grid-cols-1 md:grid-cols-2 md:gap-4 box-border mx-auto"
      style={{ height: belowMd ? undefined : 643 }}
    >
      <div className={`flex justify-center items-center ${imgClassName} z-10`}>
        <ActionImage src={src} belowMd={belowMd} />
      </div>
      <div className={`flex justify-center items-center ${textClassName} z-1`}>
        <ActionText title={title} buttonText={buttonText} belowMd={belowMd}>
          {children}
        </ActionText>
      </div>
    </div>
  );
};
export default ActionCard;